import { z } from 'zod';
import { SessionListItemSchema } from '../session';
import { PublishedStudyDetailSchema } from './entity';
import { SubmitAnswerSchema } from '../questionnaire/answers';

export const ParticipantStudyDtoSchema = PublishedStudyDetailSchema.omit({
  targetPopulation: true,
}).extend({
  hasConsentedToStudyAt: z.string().datetime().nullable(),
  participantDurationInMinutes: z.number().int().positive(),
  sessions: z.array(SessionListItemSchema),
});

export type ParticipantStudyDto = z.infer<typeof ParticipantStudyDtoSchema>;

export const ParticipantHomeStudyDtoSchema = ParticipantStudyDtoSchema.omit({
  sessions: true,
}).extend({
  pendingSessions: z.array(SessionListItemSchema),
  totalSessionsAmount: z.number().int().nonnegative(),
});

export type ParticipantHomeStudyDto = z.infer<
  typeof ParticipantHomeStudyDtoSchema
>;

export const SetConsentDTOSchema = z.object({
  timezone: z
    .string()
    .min(1)
    .describe('IANA timezone identifier (e.g., "America/New_York")'),
  initialQuestionnaireAnswers: SubmitAnswerSchema,
});

export type SetConsentDTO = z.infer<typeof SetConsentDTOSchema>;

export const SetConsentErrorSchema = z.discriminatedUnion('code', [
  z.object({ code: z.literal('ALREADY_ANSWERED'), message: z.string() }),
]);

export type SetConsentError = z.infer<typeof SetConsentErrorSchema>;

export const isSetConsentError = (e: unknown): e is SetConsentError =>
  SetConsentErrorSchema.safeParse(e).success;
